<template lang="pug">
history-list
</template>

<script>
import HistoryList from '@components/history_list.vue'
export default {
  components: {
    HistoryList
  }
}
</script>
